import { bindHTTP } from '@frontend/schema';
import { VoicemailConfigService } from '@weave/schema-gen-ts/dist/schemas/phone/voicemail-config/v2/voicemail_config_service.pb';
export const SchemaVoicemailConfigService = bindHTTP(VoicemailConfigService);
